import { render, staticRenderFns } from "./ManageMenu.vue?vue&type=template&id=fd8b72b2&scoped=true&lang=pug&"
import script from "./ManageMenu.vue?vue&type=script&lang=js&"
export * from "./ManageMenu.vue?vue&type=script&lang=js&"
import style0 from "./ManageMenu.vue?vue&type=style&index=0&id=fd8b72b2&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd8b72b2",
  null
  
)

export default component.exports